import {
  Debounce,
  GlobalEvents,
  SnippetElement,
  defineElement,
  globalOn,
  onClick,
  param,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XS5WIYU5.js";

// src/sections/common-main-blog/common-main-blog.ts
var _a, _b, _c;
var CommonMainBlog = class extends SnippetElement {
  constructor() {
    super(...arguments);
    this.baseUrl = `${(_c = (_b = (_a = window.Shopify) == null ? void 0 : _a.routes) == null ? void 0 : _b.root) != null ? _c : ""}`;
  }
  get loading() {
    var _a2, _b2;
    return (_b2 = (_a2 = this.resultBar) == null ? void 0 : _a2.hasAttribute("loading")) != null ? _b2 : false;
  }
  set loading(val) {
    var _a2, _b2;
    if (val) {
      (_a2 = this.resultBar) == null ? void 0 : _a2.setAttribute("loading", "");
    } else {
      (_b2 = this.resultBar) == null ? void 0 : _b2.removeAttribute("loading");
    }
  }
  connectedCallback() {
    var _a2, _b2;
    const debouncedRender = Debounce.debounce(() => {
      this.fetchPredictiveSearch();
    }, (_a2 = this.time) != null ? _a2 : 800);
    (_b2 = this.predictiveSearch) == null ? void 0 : _b2.addEventListener("input", () => {
      var _a3, _b3;
      this.output.innerHTML = "";
      (_a3 = this.raw) == null ? void 0 : _a3.classList.add("hidden");
      this.loading = true;
      (_b3 = this.resultBar) == null ? void 0 : _b3.classList.remove("hidden");
      debouncedRender();
    });
  }
  resetInput() {
    var _a2, _b2, _c2;
    console.log("reset");
    (_a2 = this.predictiveSearch) == null ? void 0 : _a2.setAttribute("value", "");
    this.predictiveSearch.value = "";
    this.output.innerHTML = "";
    (_b2 = this.resultBar) == null ? void 0 : _b2.classList.add("hidden");
    (_c2 = this.raw) == null ? void 0 : _c2.classList.remove("hidden");
    this.loading = false;
  }
  fetchPredictiveSearch() {
    return __async(this, null, function* () {
      var _a2, _b2, _c2, _d;
      if (((_a2 = this.predictiveSearch) == null ? void 0 : _a2.value) === "") {
        this.resetInput();
        return;
      }
      const response = yield fetch(`${this.baseUrl}search/suggest?q=${(_c2 = (_b2 = this.predictiveSearch) == null ? void 0 : _b2.value) != null ? _c2 : ""}&resources[type]=article&section_id=ajax-blog-search`);
      if (response.status === 422) {
        this.loading = false;
        return;
      }
      const text = yield response.text();
      const html = document.createElement("div");
      html.innerHTML = text;
      if (this.output) {
        this.output.innerHTML = html.innerHTML;
      }
      this.loading = false;
      (_d = this.resultBar) == null ? void 0 : _d.classList.add("hidden");
      GlobalEvents.emit("recommendation:performed");
    });
  }
  showResults() {
    var _a2;
    (_a2 = this.resultBar) == null ? void 0 : _a2.classList.remove("hidden");
  }
};
__decorateClass([
  query("[data-output]")
], CommonMainBlog.prototype, "output", 2);
__decorateClass([
  query("[data-raw]")
], CommonMainBlog.prototype, "raw", 2);
__decorateClass([
  query("[data-predictive-search]")
], CommonMainBlog.prototype, "predictiveSearch", 2);
__decorateClass([
  query("[data-result-bar]")
], CommonMainBlog.prototype, "resultBar", 2);
__decorateClass([
  param()
], CommonMainBlog.prototype, "time", 2);
__decorateClass([
  onClick("[data-input-reset]")
], CommonMainBlog.prototype, "resetInput", 1);
__decorateClass([
  globalOn("recommendation:performed")
], CommonMainBlog.prototype, "showResults", 1);
CommonMainBlog = __decorateClass([
  defineElement("common-main-blog")
], CommonMainBlog);
export {
  CommonMainBlog
};
